export enum ReviewProduct {
  All = 'All',
  Renters = 'Renters',
  Home = 'Homeowners',
  Car = 'Car',
  Pet = 'Pet',
  Life = 'Life',
}

export enum ReviewType {
  Video = 'video',
  Text = 'text',
}

export enum ReviewSource {
  AppStore = 'App Store',
  GooglePlay = 'Google Play',
  X = 'X',
  TrustPilot = 'Trustpilot',
  AppFollow = 'AppFollow',
  NerdWallet = 'NerdWallet',
  ConsumerAffairs = 'ConsumerAffairs',
  Bbb = 'BBB',
  Internalreview = 'Internal Review',
  Clearsurance = 'Clearsurance',
}

interface BaseReview {
  reviewerName: string;
  id?: number;
  product?: ReviewProduct[];
  displayInHomePage?: boolean;
}

export interface VideoReview extends BaseReview {
  type: ReviewType.Video;
  videoUrl: string;
  posterUrl?: { src: string };
  captionsUrl: string;
}

export interface TextReview extends BaseReview {
  type: ReviewType.Text;
  shortText: string;
  fullText: string;
  source: ReviewSource;
}

export const ASSETS_URL = 'https://assets.lemonade.com/reviews';
